import { FC, HTMLAttributes, ReactNode } from 'react';

const TooltipListTitle: FC<HTMLAttributes<HTMLDivElement> & { title: string | ReactNode }> = ({
  title,
  ...divProps
}) => {
  return (
    <div style={{ fontSize: '14px', lineHeight: '21px', marginBottom: '5.5px' }} {...divProps}>
      {title}
    </div>
  );
};
export default TooltipListTitle;
